<div [id]="backgroundImageId" class="bg-image shadow" color="primary">
  <div class="mask d-flex align-items-center h-100">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-10 col-md-10 col-lg-6 col-xl-5 col-xxl-4">
          <form class="bg-white rounded shadow-5-strong p-4">
            <div class="d-flex justify-content-center" >
              <div class="col-md-8 col-sm-12 d-flex justify-content-center">
                <img [src]="logoUrl" alt="IEA logo" class="logo" />
              </div>
            </div>
            <div class="col-12 text-center">

              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 186 165" fill="none">
                  <path d="M93 8C51.6454 8 18 41.6454 18 83C18 124.355 51.6454 158 93 158C134.355 158 168 124.355 168 83C168 41.6454 134.355 8 93 8ZM132.032 57.8642L83.5709 115.556C83.0393 116.19 82.3779 116.701 81.6313 117.056C80.8848 117.412 80.0706 117.602 79.244 117.615H79.1466C78.338 117.615 77.5384 117.445 76.7999 117.116C76.0613 116.786 75.4002 116.306 74.8594 115.704L54.0901 92.6274C53.5627 92.068 53.1524 91.4087 52.8833 90.6884C52.6143 89.9681 52.4919 89.2013 52.5235 88.4331C52.555 87.6648 52.7398 86.9106 53.0669 86.2148C53.3941 85.519 53.8571 84.8956 54.4286 84.3813C55.0002 83.8669 55.6688 83.472 56.3951 83.2198C57.1214 82.9675 57.8909 82.863 58.6582 82.9124C59.4255 82.9617 60.1752 83.164 60.8632 83.5072C61.5513 83.8504 62.1637 84.3277 62.6647 84.9111L78.9952 103.055L123.198 50.4435C124.19 49.2972 125.593 48.587 127.104 48.4666C128.614 48.3463 130.112 48.8253 131.273 49.8001C132.433 50.775 133.163 52.1674 133.306 53.6764C133.448 55.1853 132.99 56.6897 132.032 57.8642Z" fill="#7D9B6B" />
                </svg>
              </div>
              <h1 class="">Verification Email Sent!</h1>
              <p class="">
                Please check your email to complete account setup. <br> Didn’t receive a code? Check your junk mail or
                click below to resend verification email.
              </p>
            </div>
            
            <!-- Submit button -->
            <button type="button" (click)="navigateToSignupVerify()" class="btn btn-primary btn-block w-100 py-2 mt-3">
              Enter Verification Code
            </button>

            <div class="col-12 text-center mt-3">
              <img class="footer-logo" src="../../../assets/images/poweredby-OneEquineblack-logo.png" alt="IEA logo" />
            </div>

          </form>

          <div class="col-12 mt-3 p-2 alert-box">
            <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
              <symbol id="check-circle-fill" fill="currentColor" viewBox="0 0 16 16">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
              </symbol>
              <symbol id="info-fill" fill="currentColor" viewBox="0 0 16 16">
                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
              </symbol>
              <symbol id="exclamation-triangle-fill" fill="currentColor" viewBox="0 0 16 16">
                <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
              </symbol>
            </svg> 

            <div class="alert alert-success d-flex align-items-center" role="alert">
              <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Success:"><use xlink:href="#check-circle-fill"/></svg>
              <div>
              <strong>Success!</strong>   We’ve sent an email with your verification code to your email address.  
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
